import React from 'react';
import './Editable.css';
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";
import {fromDateString, KensuDate, toDateString} from "../../util/DateTimeUtils";

export const EditableDateField = <EnclosingType extends object>(props: EditableProps<EnclosingType, KensuDate>) => {

  const {value, setValue, mode, editing} = useEditable<EnclosingType, KensuDate>(props);

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {
    return <Editable {...props}>
      <input type={'date'} className={'EditableEditing'}
             value={toDateString(value)}
             onChange={event => {
               console.log(event.target.value)
               setValue(fromDateString(event.target.value))
             }}/>
    </Editable>
  }

  return <Editable {...props}>
    <div className={'EditableNotEditing'}>{toDateString(value)}</div>
  </Editable>
}